import { render, staticRenderFns } from "./garland.vue?vue&type=template&id=b1841314&"
import script from "./garland.vue?vue&type=script&lang=js&"
export * from "./garland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports